import { useState } from 'react'
import { ThemeProvider } from '@mui/material/styles'
import { ReactKeycloakProvider } from '@react-keycloak/web'
import { rubricaeTheme } from '../../theming'
import keycloak from '../../Keycloak'
import { ErrorContexts } from '../../contexts/ErrorContext'
import AppRouter from '../../router/AppRouter'
import Layout from '../../layouts/Layout'
import './App.scss'
import ErrorFallback from '../../components/Error/ErrorFallback'

const App = () => {
  const [error, setError] = useState(null)

  return (
    <ThemeProvider theme={rubricaeTheme}>
      <ErrorContexts.Provider value={{ error, setError }}>
        <ReactKeycloakProvider
          initOptions={{ onLoad: 'login-required' }}
          authClient={keycloak}>
          <Layout>
            {error ? <ErrorFallback /> : <></>}
            <AppRouter />
          </Layout>
        </ReactKeycloakProvider>
      </ErrorContexts.Provider>
    </ThemeProvider>
  )
}

export default App
